import React, { Component } from 'react';
import './App.css';
import './index.css';
import { Carousel } from 'react-bootstrap';

export default class ControlledCarousel extends Component {

    constructor(props) {
        super(props);
        this.state= {
            index: 0,
            direction: null,
        };
        this.handleSelect = this.handleSelect.bind(this);
    }

    handleSelect(selectedIndex, e) {
        this.setState({
            index: selectedIndex,
            direction: e.direction
        });
    }

    /* After component mounts, remove arrows on carousel if only one image/video.
    Must be done here since we cannot get the class 'carousel-control' until component is mounted */
    componentDidMount() {
        let controlElements = document.getElementsByClassName('carousel-control');
        if ((this.props.images && this.props.videos && (this.props.images.length + this.props.videos.length === 1) && controlElements.length === 2) ||
        (this.props.images && this.props.images.length === 1 && controlElements.length === 2) ||
        (this.props.videos && this.props.images.videos === 1 && controlElements.length === 2)) {
            controlElements[0].style.display = 'none';
            controlElements[1].style.display = 'none';
        }
    }

    render() {

        // Only renders carousel object if there are any videos or images
        if (this.props.images.length > 0 || this.props.videos) {
            return (
                <Carousel className="carousel" activeIndex={this.state.index} direction={this.state.direction} onSelect={this.handleSelect}>
                    {
                        this.props.images &&
                        this.props.images.map(function (image, index) {
                            return (
                                <Carousel.Item key={index}>
                                    <img alt="900x500" src={image.source}/>
                                    <Carousel.Caption>
                                        <div>
                                            <p className="carAuthor">{image.author}</p>
                                            <p className="carCaption">{image.caption}</p>
                                        </div>
                                    </Carousel.Caption>
                                </Carousel.Item>
                            );
                        })
                    }
                    {
                        this.props.videos &&
                        this.props.videos.map(function (video, index) {
                            return (
                                <Carousel.Item key={index}>
                                    <iframe className="carVideo" src={video} frameBorder="0" allowFullScreen></iframe>
                                </Carousel.Item>
                            );
                        })
                    }
                </Carousel>
            );
        }
        else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/Carousel.js